import {
    Stethoscope, Sparkles, Activity, Syringe, Layers, Crown, Anchor, Smile,
    Sun, Gem, Leaf, Ruler, Baby, Zap, Users, LayoutGrid, Microscope,
    MessageSquare, ShieldCheck, HeartPulse,
} from "lucide-react";

export const PHONE_DISPLAY = "+91 62909 07195";
export const PHONE_TEL = "tel:+916290907195";
export const GOOGLE_PROFILE_URL = "https://maps.app.goo.gl/C5bcqrsYcL43JhLM9";
export const ADDRESS = "Ward No. 34, 117/13, Mirpara Rd, PO Bhattanagar, Bhatta Nagar, Liluah, Howrah, West Bengal 711203";

export const services = [
    { icon: Stethoscope, title: "General Dental Consultation", desc: "Complete oral health check-up with clear, honest guidance." },
    { icon: Sparkles, title: "Teeth Cleaning & Polishing", desc: "Gentle professional cleaning for a fresher smile." },
    { icon: Activity, title: "Root Canal Treatment", desc: "Careful treatment to relieve pain and save an infected tooth." },
    { icon: Syringe, title: "Tooth Extraction", desc: "Safe, comfortable removal when a tooth cannot be saved." },
    { icon: Layers, title: "Dental Fillings", desc: "Durable, tooth-coloured fillings to restore decayed teeth." },
    { icon: Crown, title: "Dental Crowns & Bridges", desc: "Natural-looking restoration for damaged or missing teeth." },
    { icon: Anchor, title: "Dental Implants", desc: "A stable, long-term replacement option for missing teeth." },
    { icon: Smile, title: "Dentures", desc: "Comfortable, well-fitting full and partial dentures." },
    { icon: Sun, title: "Teeth Whitening", desc: "Professional whitening for a visibly brighter smile." },
    { icon: Gem, title: "Cosmetic Dentistry", desc: "Thoughtful treatments that enhance your smile's appearance." },
    { icon: Leaf, title: "Gum Care", desc: "Dedicated care for healthy gums and a stronger foundation." },
    { icon: Ruler, title: "Braces & Teeth Alignment", desc: "Guided options to straighten teeth and improve your bite." },
    { icon: Baby, title: "Pediatric Dental Care", desc: "Gentle, friendly dental care designed for children." },
    { icon: Zap, title: "Emergency Dental Consultation", desc: "Prompt attention for dental pain and urgent concerns." },
];

export const serviceOptions = [
    "General Consultation",
    "Teeth Cleaning & Polishing",
    "Root Canal Treatment",
    "Tooth Extraction",
    "Dental Filling",
    "Dental Crown / Bridge",
    "Dental Implant",
    "Dentures",
    "Teeth Whitening",
    "Cosmetic Dentistry",
    "Gum Treatment",
    "Braces / Teeth Alignment",
    "Pediatric Dental Care",
    "Emergency Consultation",
    "Other",
];

export const timeOptions = (() => {
    const out = [];
    for (let h = 9; h <= 20; h++) {
        for (const m of ["00", "30"]) {
            if (h === 20 && m === "30") break;
            const ampm = h < 12 ? "AM" : "PM";
            const hr12 = ((h + 11) % 12) + 1;
            out.push(`${String(hr12).padStart(2, "0")}:${m} ${ampm}`);
        }
    }
    return out;
})();

export const whyChoose = [
    { icon: Users, title: "Personalized Care", desc: "Every treatment plan is shaped around your individual needs and comfort." },
    { icon: LayoutGrid, title: "Comprehensive Dental Services", desc: "From routine check-ups to advanced care, all under one roof." },
    { icon: Smile, title: "Patient-Friendly Experience", desc: "A calm, welcoming visit designed to put you at ease." },
    { icon: Microscope, title: "Modern Treatment Approach", desc: "A careful, up-to-date approach to diagnosis and treatment." },
    { icon: MessageSquare, title: "Clear Consultation", desc: "Straightforward explanations so you understand every step." },
    { icon: ShieldCheck, title: "Focus on Long-Term Oral Health", desc: "Care that looks beyond today to protect your smile for years." },
];

export const processSteps = [
    { num: "01", title: "Book Your Visit", desc: "Send an appointment request with your preferred date and time." },
    { num: "02", title: "Consult With the Dentist", desc: "Discuss your concerns and get a clear picture of your oral health." },
    { num: "03", title: "Receive Your Treatment Guidance", desc: "Leave with a clear, personalized plan for your dental care." },
];

export const featuredHighlights = [
    { icon: ShieldCheck, title: "Preventive Dental Care", desc: "Regular check-ups and cleaning that stop small issues from becoming big ones." },
    { icon: HeartPulse, title: "Restorative Treatment", desc: "Fillings, crowns, root canals and more to bring damaged teeth back to health." },
    { icon: Sparkles, title: "Smile Improvement", desc: "Whitening and cosmetic options that help you smile with confidence." },
];

export const faqs = [
    {
        q: "How can I book a dental appointment?",
        a: "Fill in the appointment form on this page or call us at +91 62909 07195. Your booking request opens in WhatsApp, where you can review and send it to the clinic for confirmation.",
    },
    {
        q: "What dental services are available?",
        a: "We offer general consultations, cleaning and polishing, root canal treatment, extractions, fillings, crowns and bridges, implants, dentures, whitening, cosmetic dentistry, gum care, braces and alignment, pediatric care and emergency consultations.",
    },
    {
        q: "Can I book an appointment through WhatsApp?",
        a: "Yes. The appointment form prepares a WhatsApp message with all your details. You simply review it and send it to the clinic.",
    },
    {
        q: "Do I need an appointment before visiting?",
        a: "We recommend booking ahead so we can reserve dedicated time for you and keep your visit smooth and unhurried.",
    },
    {
        q: "What should I bring for my first dental consultation?",
        a: "Bring any previous dental records or X-rays you may have, along with a list of medications you are currently taking. This helps the dentist understand your history better.",
    },
    {
        q: "How can I get directions to the clinic?",
        a: "Use the Get Directions button in the Contact section to open our location in Google Maps and navigate straight to the clinic.",
    },
];
